package game.entity

import game.Game
import game.Room
import game.TileType
import kotlin.random.Random

class Worm(hp: Int, damage: Int, val spriteId: String, projectileSpeed: Double, tileType: TileType = TileType.Floor) : Enemy(hp, damage * 2) {
    val projectileDuration = 200
    var projectileCoolDown = Random.nextInt(projectileDuration / 2, projectileDuration)
    val wanderComponent = WanderComponent(12, false, tileType)
    val projectile = Projectile(projectileSpeed, 1, damage)

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(spriteId)
    }

    override fun onTick(game: Game, room: Room) {
        wanderComponent.tick(game, room, this)

        if (projectileCoolDown > 0) {
            projectileCoolDown--
        } else {
            projectileCoolDown = projectileDuration

            projectile.startAttack(game, col, row, game.player.col, game.player.row, "red-mucus-ball")
            room.addEntity(projectile)
        }
    }
}